module.exports = __webpack_public_path__ + "img/zan-gif.ce891b1e.gif";